// const host_url = 'http://192.168.1.15:8080/';
const host_url = 'http://ec2-35-180-227-239.eu-west-3.compute.amazonaws.com:8080/blog-server/';

export async function fetchRecipes() {
    const response = await fetch(`${host_url}api/recipes`);
    return await response.json();
}

export async function fetchRecipe(label) {
    const response = await fetch(`${host_url}api/articles/article/${label}`);
    return await response.json();
}

export async function insertRecipeView(recipeId) {
    const response = await fetch(`${host_url}api/articles/article/${recipeId}/view`, {
        method: 'post',
        mode: 'no-cors',
    });
    return await response;
}



// WEBPACK FOOTER //
// ./src/service/recipes.js